// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var SelectionSemantics__InputCursorSemantics$SmartcutsMacros = require("./SelectionSemantics__InputCursorSemantics.bs.js");
var SelectionSemantics__InputSelectionSemantics$SmartcutsMacros = require("./SelectionSemantics__InputSelectionSemantics.bs.js");

function t_encode(v) {
  if (v.TAG === /* InputSelectionSemantic */0) {
    return [
            "InputSelectionSemantic",
            SelectionSemantics__InputSelectionSemantics$SmartcutsMacros.Semantic.t_encode(v._0)
          ];
  } else {
    return [
            "InputCursorSemantic",
            SelectionSemantics__InputCursorSemantics$SmartcutsMacros.Semantic.t_encode(v._0)
          ];
  }
}

function t_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "InputCursorSemantic" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = SelectionSemantics__InputCursorSemantics$SmartcutsMacros.Semantic.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* InputCursorSemantic */1,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "InputSelectionSemantic" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = SelectionSemantics__InputSelectionSemantics$SmartcutsMacros.Semantic.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* InputSelectionSemantic */0,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function toHumanReadable(v) {
  if (v.TAG === /* InputSelectionSemantic */0) {
    return SelectionSemantics__InputSelectionSemantics$SmartcutsMacros.Semantic.toHumanReadable(v._0);
  } else {
    return SelectionSemantics__InputCursorSemantics$SmartcutsMacros.Semantic.toHumanReadable(v._0);
  }
}

function selectOrMoveCursorInsideInput(element, semantic) {
  if (semantic.TAG === /* InputSelectionSemantic */0) {
    var func = SelectionSemantics__InputSelectionSemantics$SmartcutsMacros.Semantic.selectInsideInput;
    return Curry._2(func, element, semantic._0).then(function (result) {
                if (result.TAG === /* Ok */0) {
                  return Promise.resolve({
                              TAG: /* Ok */0,
                              _0: undefined
                            });
                } else {
                  return Promise.resolve({
                              TAG: /* Error */1,
                              _0: {
                                TAG: /* InputSelectionSemanticError */1,
                                _0: result._0
                              }
                            });
                }
              });
  }
  var func$1 = SelectionSemantics__InputCursorSemantics$SmartcutsMacros.Semantic.moveCursorInsideInput;
  return Curry._2(func$1, element, semantic._0).then(function (result) {
              if (result.TAG === /* Ok */0) {
                return Promise.resolve({
                            TAG: /* Ok */0,
                            _0: undefined
                          });
              } else {
                return Promise.resolve({
                            TAG: /* Error */1,
                            _0: {
                              TAG: /* InputCursorSemanticError */2,
                              _0: result._0
                            }
                          });
              }
            });
}

function selectOrMoveCursorInsideInputLocatedAtSelector(selector, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand, semantic) {
  if (semantic.TAG === /* InputSelectionSemantic */0) {
    var func = SelectionSemantics__InputSelectionSemantics$SmartcutsMacros.Semantic.selectInsideInputLocatedAtSelector;
    var func$1 = Curry._1(func, selector);
    return Curry._2(func$1, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand, semantic._0).then(function (result) {
                if (result.TAG === /* Ok */0) {
                  return Promise.resolve({
                              TAG: /* Ok */0,
                              _0: undefined
                            });
                } else {
                  return Promise.resolve({
                              TAG: /* Error */1,
                              _0: result._0
                            });
                }
              });
  }
  var func$2 = SelectionSemantics__InputCursorSemantics$SmartcutsMacros.Semantic.moveCursorInsideInputLocatedAtSelector;
  var func$3 = Curry._1(func$2, selector);
  return Curry._2(func$3, dispatchHideSmartcutsPlaybackModalUntilCompletedCommand, semantic._0).then(function (result) {
              if (result.TAG === /* Ok */0) {
                return Promise.resolve({
                            TAG: /* Ok */0,
                            _0: undefined
                          });
              } else {
                return Promise.resolve({
                            TAG: /* Error */1,
                            _0: result._0
                          });
              }
            });
}

var Semantic = {
  t_encode: t_encode,
  t_decode: t_decode,
  toHumanReadable: toHumanReadable,
  selectOrMoveCursorInsideInput: selectOrMoveCursorInsideInput,
  selectOrMoveCursorInsideInputLocatedAtSelector: selectOrMoveCursorInsideInputLocatedAtSelector
};

function t_encode$1(v) {
  return Decco.arrayToJson(t_encode, v);
}

function t_decode$1(v) {
  return Decco.arrayFromJson(t_decode, v);
}

function stringify(semantics) {
  return "[" + ($$Array.map(toHumanReadable, semantics).join(", ") + "]");
}

function ofSelectionOrCursor(param) {
  var value = param.value;
  var params = param.params;
  var domElementRepresentation = param.domElementRepresentation;
  if (typeof params === "number") {
    return [];
  }
  if (params.TAG !== /* InputSelectionParams */0) {
    return $$Array.map((function (semantic) {
                  return {
                          TAG: /* InputCursorSemantic */1,
                          _0: semantic
                        };
                }), SelectionSemantics__InputCursorSemantics$SmartcutsMacros.ofInputCursor({
                    domElementRepresentation: domElementRepresentation,
                    cursorPosition: params._0,
                    value: value
                  }));
  }
  var match = params._0;
  return $$Array.map((function (semantic) {
                return {
                        TAG: /* InputSelectionSemantic */0,
                        _0: semantic
                      };
              }), SelectionSemantics__InputSelectionSemantics$SmartcutsMacros.ofSelection({
                  domElementRepresentation: domElementRepresentation,
                  value: value,
                  start: match.start,
                  end_: match.end_,
                  selectionDirection: match.selectionDirection
                }));
}

var InputSelectionSemantics;

var InputCursorSemantics;

exports.InputSelectionSemantics = InputSelectionSemantics;
exports.InputCursorSemantics = InputCursorSemantics;
exports.Semantic = Semantic;
exports.t_encode = t_encode$1;
exports.t_decode = t_decode$1;
exports.stringify = stringify;
exports.ofSelectionOrCursor = ofSelectionOrCursor;
/* SelectionSemantics__InputCursorSemantics-SmartcutsMacros Not a pure module */
